import * as React from 'react'

function SvgWithdrawalTwoTone(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 30 30" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.5 3A1.5 1.5 0 0025 4.5V8H5V4.5a1.5 1.5 0 10-3 0V9a2 2 0 002 2h22a2 2 0 002-2V4.5A1.5 1.5 0 0026.5 3z"
        fill="#1B2736"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.91 27.53c.273.29.66.47 1.09.47.407 0 .777-.163 1.047-.427l4.665-4.492a1.5 1.5 0 10-2.08-2.161l-2.133 2.053V15a1.5 1.5 0 10-3 0v7.776l-1.746-1.816a1.5 1.5 0 10-2.162 2.08l4.319 4.49z"
        fill="currentColor"
      />
    </svg>
  )
}

export default SvgWithdrawalTwoTone
